import { BoardsListSection } from './ui';

export function BoardsPage() {
  return <BoardsListSection />;
}
